// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__tEL+i","menuItemActive":"MenuItem_menuItemActive__CYeWT"};